import { HttpService } from "@/core";

import { ApprovalFLowLogPageReq, ApprovalFLowLogListResp } from "./approval-flow-log.interface";

export class ApprovalFlowLogService {
  static usePageApi() {
    const api = (params: ApprovalFLowLogPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/examine_log/page",
        params,
      });
    return HttpService.usePagination<ApprovalFLowLogListResp>(api);
  }
  static useGetLogs() {
    const api = (bizId,bizType) =>
      HttpService.axios({
        method: "GET",
        url: `/common_api/getRecycleLog/${bizId}/${bizType}`,
      });
    return HttpService.useRequest<any>(api);
  }
}
